<template>
  <div class="page">
    <z-header></z-header>
    <div class="min_width">
      <div class="download_page">
        <div class="info_box">
          <!-- phone -->
          <div class="input_box">
            <label class="label">手机号</label>
            <div class="input_tag_box">
              <div class="input_info">
                <input type="number" v-model="phone" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入注册手机号" />
              </div>
              <div class="user_info" v-if="info.token">
                <img :src="info.avatar" />
                <span>{{ info.nickname }}</span>
              </div>
              <div class="tag" v-else>*点击登录后，请确认头像和昵称</div>
            </div>
            <button class="phone_btn" @click="onComfirm">登录</button>
          </div>
          <!-- recharge -->
          <div class="recharge_box">
            <label class="label">充值金额</label>
            <div>
              <div class="recharge_info">
                <div class="re_item" :class="{ active: reIndex == item.num }" @click="onRecharge(item)" v-for="(item, index) in rechargeList" :key="index">
                  <img src="../../assets/ic_gold.png" alt="" />
                  <div>{{ item.num }}金币</div>
                  <span>{{ item.num }}元</span>
                </div>
              </div>
              <div class="input_tag_box">
                <div class="input_info">
                  <input type="number" v-model="num" @input="onInput" placeholder="请输入充值金额" />
                  <span>元</span>
                </div>
                <div class="tag">*1元=1金币，购买金币后不可提现</div>
              </div>
            </div>
          </div>
        </div>
        <div class="info_box">
          <div class="down_way_box">
            <label class="label">充值方式</label>
            <div class="input_tag_box">
              <div class="down_way">
                <div class="btn" :class="{ active: paytype == 1 }" @click="paytype = 1">
                  <span class="ios">微信</span>
                </div>
                <div class="btn" :class="{ active: paytype == 2 }" @click="paytype = 2">
                  <span class="android">支付宝</span>
                </div>
              </div>
              <div class="tag">
                *温馨提示：切勿轻信刷单、低价充值等类似得言论，谨防上当受骗
              </div>
            </div>
            <button class="recharge_btn" @click="onSubmit">立即充值</button>
          </div>
        </div>
      </div>
    </div>
    <z-popup v-model="payPopup" type="2000">
      <div class="pay_box">
        <img :src="wechatImg" />
        <span>请用微信扫码支付</span>
      </div>
    </z-popup>
    <z-footer></z-footer>
  </div>
</template>
<script>
import { mapState } from "vuex";
import zPopup from "@/components/common/popup";
let clearInter;
export default {
  name: "Home",
  components: {
    zPopup,
  },
  data() {
    return {
      reIndex: 0,
      phone: "",
      info: {},
      num: "",
      token: "",
      //支付方式
      paytype: 9999,
      payPopup: false,
      wechatImg: "",
      orderNo: "",
      rechargeList: [
        {
          num: "10",
        },
        {
          num: "30",
        },
        {
          num: "50",
        },
        {
          num: "100",
        },
        {
          num: "500",
        },
        {
          num: "1000",
        },
      ],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() { },
  mounted() { },
  methods: {
    onPageJump(url) {
      this.$router.push(url);
    },
    onRecharge(item) {
      this.reIndex = item.num;
      this.num = item.num;
    },
    onComfirm() {
      if (!this.phone) {
        this.$prompt("请输入手机号");
        return;
      }
      this.info = {};
      this.$http
        .get("api/v1/web/getUinfo", {
          phone: this.phone,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.info = res.data;
          }
        });
      // this.$prompt('该手机号码不存在');
    },
    onInput() {
      this.reIndex = 9999;
      setTimeout(() => {
        this.num = Math.ceil(this.num);
      }, 500);
    },
    onSubmit() {
      if (!this.phone) {
        this.$prompt("请输入手机号");
        return;
      }
      if (!this.info.token) {
        this.$prompt("请按“确定”，确认用户信息");
        return;
      }
      if (!this.num) {
        this.$prompt("请选择或填写充值金额");
        return;
      }
      if (this.num == 0) {
        this.$prompt("最小充值金额为1");
        return;
      }
      if (this.paytype == 9999) {
        this.$prompt("请选择充值方式");
        return;
      }
      let httpData = {
        token: this.info.token,
        timestamp: this.info.timestamp,
        paytype: this.paytype,
        num: this.num,
        phone: this.phone,
      };
      console.log(httpData);
      this.$http.post("api/v1/web/recharge", httpData).then((res) => {
        this.orderNo = res.data.rid;
        if (this.paytype == 1) {
          this.wechatImg = res.data.code_img;
          this.payPopup = true;
          setTimeout(() => {
            this.onWxPay();
          }, 2000);
        } else {
          window.open(res.data.pay);
          setTimeout(() => {
            this.onWxPay();
          }, 2000);
        }
        this.$prompt("发起支付成功");
      });
    },
    onWxPay() {
      clearInter && clearInterval(clearInter);
      let index = 0;
      clearInter = setInterval(() => {
        index++;
        if (index <= 30 && this.payPopup) {
          this.$http
            .post(
              "api/v1/web/payCall",
              {
                rid: this.orderNo,
              },
              {
                load: false,
              }
            )
            .then((res) => {
              if (res.code == 200) {
                this.$prompt("支付成功");
                setTimeout(() => {
                  this.$router.push("/paySuccess");
                }, 500);
                clearInter && clearInterval(clearInter);
              }
            });
        } else {
          clearInter && clearInterval(clearInter);
          this.onWxPay();
        }
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  // background-image: url("http://qn.kemean.cn/upload/202102/04/1612408270171vkjf43h6.png");
  background-color: #ffffff;
  width: 100%;
  height: 1080px;
  .download_page {
    min-height: 920px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    min-width: 1500px;
    width: 1500px;
    margin: 0 auto;
    .info_box {
      width: 100%;
      border-radius: 4px;
      border: 1px solid #c7c8cb;
      padding: 40px;
      margin-bottom: 20px;
      padding-left: 324px;
      .label {
        margin-top: 10px;
        width: 60px;
        text-align: right;
        font-size: 14px;
        color: #333333;
      }
      .recharge_btn {
        width: 86px;
        height: 40px;
        background: #466bfe;
        box-shadow: 0px 2px 4px 0px rgba(80, 100, 236, 0.33);
        border-radius: 4px;
        margin-left: 280px;
        font-size: 14px;
        color: #ffffff;
      }
      .recharge_btn:hover {
        transition: all 0.4s;
        background: #143bd7;
      }
      .phone_btn {
        width: 86px;
        height: 40px;
        background: #466bfe;
        box-shadow: 0px 2px 4px 0px rgba(80, 100, 236, 0.33);
        border-radius: 4px;
        margin-left: 40px;
        font-size: 14px;
        color: #ffffff;
      }
      .input_box {
        display: flex;
      }
      .down_way_box {
        display: flex;
        .down_way {
          // margin-left: 40px;
          display: flex;

          .btn {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            // padding: 0 30px;
            width: 158px;
            height: 40px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #cdced5;
            text-align: center;
            margin-right: 20px;
            .ios {
              display: flex;
              align-items: center;
              &::before {
                content: "";
                @include bis("../../assets/ic_weixin_c.png");
                margin-right: 16px;
                width: 24px;
                height: 24px;
              }
            }
            .android {
              display: flex;
              align-items: center;
              &::before {
                content: "";
                @include bis("../../assets/ic_zhifubao.png");
                margin-right: 16px;
                width: 24px;
                height: 24px;
              }
            }
            span {
              color: #333333;
              font-size: 14px;
            }
          }
          // 鼠标悬浮效果
          .btn:hover,
          .active {
            transition: all 0.4s;
            background: #466bfe;
            border-radius: 6px;
            .ios {
              &::before {
                content: "";
                @include bis("../../assets/ic_weixin_white.png");
                margin-right: 16px;
                width: 24px;
                height: 24px;
              }
            }
            .android {
              &::before {
                content: "";
                @include bis("../../assets/ic_zhifubao_white.png");
                margin-right: 16px;
                width: 24px;
                height: 24px;
              }
            }
            span {
              color: #fff;
            }
          }
        }
      }
      .recharge_box {
        margin-top: 30px;
        display: flex;
        .recharge_info {
          margin-top: 10px;
          margin-left: 40px;
          margin-bottom: 20px;
          width: 600px;
          display: flex;
          flex-wrap: wrap;

          .re_item {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 186px;
            height: 100px;
            background: rgba($color: #375cf7, $alpha: 0.1);
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            border: 1px solid rgba($color: #cdced5, $alpha: 0.1);
            margin-right: 20px;
            margin-bottom: 20px;
            &:nth-child(3n) {
              margin-right: 0px;
            }
            img {
              width: 26px;
              height: 26px;
            }
            div {
              margin-top: 4px;
              font-size: 18px;
              font-weight: 500;
              color: #365df8;
            }
            span {
              margin-top: 4px;
              font-size: 14px;
              color: #666666;
            }
          }
          .active {
            border: 1px solid #375cf7;
          }
        }
      }
      .input_tag_box {
        margin-left: 40px;
        .tag {
          margin-top: 10px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }
      }
      .input_info {
        width: 598px;
        height: 40px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #cdced5;
        display: flex;
        align-items: center;
        padding: 0 20px;
        input {
          height: 40px;
          background-color: transparent;
          flex: 1;
          border: none;
          font-size: 14px;
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }

        input[type="number"] {
          -moz-appearance: textfield;
        }
      }
      .user_info {
        display: flex;
        align-items: center;
        margin-top: 12px;
        > img {
          width: 45px;
          height: 45px;
          border-radius: 50%;
        }
        > span {
          font-size: 14px;
          color: #333333;
          margin-left: 12px;
        }
      }
    }
  }
  @font-face {
    font-family: myfont;
    src: url("~@/font/YouSheBiaoTiHei.ttf");
  }
  .pay_box {
    border-radius: 8px;
    background-color: #fff;
    padding: 32px;
    // width: 300px;
    height: 380px;
    display: flex;
    flex-direction: column;
    align-items: center;
    > img {
      width: 280px;
      height: 280px;
    }
    > span {
      margin-top: 12px;
      color: #333333;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>
